import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
  appointmentData: [],
};

const appointmentSuccess = (state, action) => {
  return {
    ...state,
    appointmentData: [...state.appointmentData, action.payload],
  };
};

const appointmentFail = (state, action) => {
  return {
    ...state,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.APPOINTMENT_SUCCESSFUL:
      return appointmentSuccess(state, action);
    case actionTypes.APPOINTMENT_FAIL:
      return appointmentFail(state, action);
    default:
      return state;
  }
};

export default reducer;
